import { library } from '@fortawesome/fontawesome-svg-core'

/* Light icons */
import { faAngleRight as falAngleRight } from '@fortawesome/pro-light-svg-icons/faAngleRight'
import { faAngleLeft as falAngleLeft } from '@fortawesome/pro-light-svg-icons/faAngleLeft'
import { faPrint as falPrint } from '@fortawesome/pro-light-svg-icons/faPrint'

import { faBoxAlt as falBoxAlt } from '@fortawesome/pro-light-svg-icons/faBoxAlt'
import { faBoxes as falBoxes } from '@fortawesome/pro-light-svg-icons/faBoxes'
import { faTimes as falTimes } from '@fortawesome/pro-light-svg-icons/faTimes'
import { faTag as falTag } from '@fortawesome/pro-light-svg-icons/faTag'

library.add(falAngleRight, falAngleLeft, falBoxAlt, falTimes, falTag, falPrint)

/* Solid icons */
import { faCheck as fasCheck } from '@fortawesome/pro-solid-svg-icons/faCheck'
import { faLockAlt as fasLockAlt } from '@fortawesome/pro-solid-svg-icons/faLockAlt'

library.add(fasLockAlt, falBoxes, fasCheck)
